import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import { PreConfigButton1 } from '../../nav-list/recursive-sidebar/configuration/preconfig';
import { PackingTrackerRoutes } from './packing-tracker-routes';
import { ShippingReceiveRoutes } from './shipping-receive-routes';
import { RepairMoldRoutes } from './repair-mold-routes';

export const AreasdeTrabajoNavRoutes: SideBarButton = {
  data: {
    name: 'Areas de trabajo',
  },
  options: PreConfigButton1,
  icon: 'work',
  butons: [PackingTrackerRoutes, ShippingReceiveRoutes, RepairMoldRoutes],
};
